module.exports = __webpack_public_path__ + "img/nda-partner.e857a1fa.svg";